import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {ACCOUNTSTATUS} from '../../constants/MicroServiceConstants';
import {
  FREQUENCY,
  DISPOSITION_CODE,
  CLOSURE_CODE,
  LEGAL_TYPE,
  CONTACT_CODE,
  PARTY,
  ACTION_TAKEN,
  PHONE_TYPE,
  GHI_DISPOSITION,
} from '../../constants/Lookup';
import {deleteWorkQueueByAccountNumber} from './WorkQueue';
import { clearWindowError, deleteModifiedWindowSessionItem, removeModifiedWindow } from "./ModifiedWindows";
import { ACCOUNT_STATUS } from "../../util/Content";

const initialData = {
  accountStatusData: {},
  dropDownData: {},
  dropDownStatusData: {},
  accountStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'accountStatus',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchAccountStatusData: (state, action) => {
      state.accountStatusData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchStatusDropDownData: (state, action) => {
      state.dropDownStatusData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAccountStatusData: (state, action) => {
      state.accountStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetAccountStatus: (state) => {
      state.accountStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchAccountStatusData,
  fetchDropDownData,
  fetchStatusDropDownData,
  resetMsg,
  postAccountStatusData,
  fetchStart,
  resetAccountStatus,
  fetchError,
} = slice.actions;

export const fetchAccountStatus = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost(`lookup/find/all/lookup`, {
        typeCode: [
          FREQUENCY,
          DISPOSITION_CODE,
          CLOSURE_CODE,
          LEGAL_TYPE,
          CONTACT_CODE,
          PARTY,
          ACTION_TAKEN,
          PHONE_TYPE,
        ],
      }),
      httpGet(`${ACCOUNTSTATUS}/find/${accountNumber}`),
    ])
      .then((data) => {
        const lookupApiData = data && data[0] ? data[0] : null;
        const findApiData = data && data[1] ? data[1] : null;
        if (lookupApiData && lookupApiData.status && lookupApiData.status === 200) {
          dispatch(fetchDropDownData(lookupApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (findApiData && findApiData.status && findApiData.status === 200) {
          dispatch(fetchAccountStatusData(findApiData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postAccountStatus = (details, isDirty) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTSTATUS}/save/accountstatus`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(
            deleteWorkQueueByAccountNumber({accountNumber: details?.accountNumber, isDirty}),
          );
          deleteModifiedWindowSessionItem(ACCOUNT_STATUS);
          dispatch(removeModifiedWindow({ windowName: ACCOUNT_STATUS }));
          dispatch(clearWindowError({ windowName: ACCOUNT_STATUS }));
          dispatch(postAccountStatusData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetAccount = () => {
  return (dispatch) => {
    dispatch(resetAccountStatus());
  };
};

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/statuslookup', {
      typeCode: [GHI_DISPOSITION],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchStatusDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
